var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"peligro"},[_c('footer',{staticClass:"peligro__bar"},[_c('peligro-color-bar',{attrs:{"ruta":_vm.colorbarMap && _vm.colorbarMap.ruta,"color-bar":_vm.colorbarMap && _vm.colorbarMap.colorbar}}),_c('desktop-footer',{staticClass:"peligro__bar__desktop-footer"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }